/*Angular Materials*/
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
/*Pipe Files*/
import { CapitalizePipe } from '../../../../pipesFiles/capitalize.pipe';
/*Html to pdf convertor */
import * as html2pdf from 'html2pdf.js';
/*Service File*/
import { SolutionFormService } from '../../../solutionForm/solutionForm.service';
/*Local Files*/
import { customerRoles, requestedWorkPage, spekwo, spekwoType } from '../../../../utils';
/*moment Package*/
import * as moment from 'moment';
/*lodash Package*/
import * as _ from 'lodash';
/*Rxjs */
import { Subscription } from 'rxjs';

@Component({
  selector: 'print-scheduling-info',
  templateUrl: './print-scheduling-info.component.html',
  styleUrls: ['./print-scheduling-info.component.scss'],
  providers: [
    CapitalizePipe,
  ]
})
export class PrintSchedulingInfoComponent implements OnInit {
  requestedWorkPage = requestedWorkPage;
  customerRoles = customerRoles;
  spekwoValues = spekwo;
  spekwoType = spekwoType;

  clientInfo: any = {
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    clientRole: '',
    agentName: '',
    agentEmail: '',
  };

  transCloseInfo: any = {
    isClose: '',
    whenClose: '',
    beginWork: '',
    closingDate: '',
  };

  closingAttroney: any = {
    name: '',
    phone: '',
  };

  questions: any = {
    whenCompleted: '',
    isPrior: '',
    isocuupied: '',
    workResponsibleRole: '',
    responisblePayment: '',
    paymentContactEmail: '',
    paymentContactPhone: '',
  };

  dayOfContact: any = {
    name: '',
    phone: '',
    email: '',
  };

  agentNames: any = {
    buyerAgentName: '',
    sellerAgentName: '',
  };
  additional: any = {
    additionalShare: '',
    additionalWork: '',
  };

  occupiedOptions = this.requestedWorkPage.occupiedOptions;
  scheduleOptions = this.requestedWorkPage.scheduleOptions;

  isPaymentClosed: boolean;
  buyerProperty: any;
  clientName: any;
  insReportId: any;
  fullName: string;
  agent: any;

  insReportIdChangeSubscription: Subscription;
  currentOrderChangedSubscription: Subscription;
  buyerPropertyChangesSubscription: Subscription;
  clientRoleChangeSubscription: Subscription;
  clientNameSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    /**Service  file */
    private solutionFormService: SolutionFormService,
    /**pipe file */
    public capitalizePipe: CapitalizePipe,
  ) { }

  ngOnInit() {
    this.getScheduleDetails(this.data);

    /**Buyer property */
    this.buyerPropertyChangesSubscription =
      this.solutionFormService.buyerPropertyChanges.subscribe(propertyRes => {
        this.buyerProperty = propertyRes;
      });

    /**Client  Name -not billing name .Its separate field */
    this.clientNameSubscription =
      this.solutionFormService.clientNameChange.subscribe(data => {
        this.clientName = data && data.name;
      });
    /**Inspection id  */
    this.insReportIdChangeSubscription =
      this.solutionFormService.insReportIdChange.subscribe(insRes => {
        this.insReportId = insRes && insRes.insReportId;
      });
    this.currentOrderChangedSubscription =
      this.solutionFormService.currentOrderChanged.subscribe(res => {
        if (res) {
          this.fullName = res.billing.first_name + ' ' + res.billing.last_name;
        }
      });
  }
  getScheduleDetails(scheduleData) {
    /* Client info */
    let clientRole = this.getvalue(this.customerRoles, scheduleData.userRole);
    this.clientInfo = {
      clientName: scheduleData && scheduleData.contactName ? scheduleData.contactName : '',
      clientEmail: scheduleData && scheduleData.contactEmail ? scheduleData.contactEmail : '',
      clientPhone: scheduleData && scheduleData.contactPhone ? scheduleData.contactPhone : '',
      clientRole: clientRole ? clientRole : '',
      agentName: scheduleData && scheduleData.agentName ? scheduleData.agentName : '',
      agentEmail: scheduleData && scheduleData.agentEmail ? scheduleData.agentEmail : '',
    };
    this.isPaymentClosed = scheduleData && scheduleData.isPaymentClosed ? scheduleData.isPaymentClosed : false,
      this.transCloseInfo = {
        isClose: scheduleData ? (scheduleData.isPaymentClosed ? 'Yes' : 'No') : '',
        whenClose: scheduleData && scheduleData.scheduleRequestDate ? moment(scheduleData.scheduleRequestDate).format('MM/DD/YYYY') : '',
        beginWork: scheduleData && scheduleData.workBeginDate ? moment(scheduleData.workBeginDate).format('MM/DD/YYYY') : '',
        closingDate: scheduleData && scheduleData.closingDate ? moment(scheduleData.closingDate).format('MM/DD/YYYY') : '',
      };
    /* Closing Attroney Info  */
    this.closingAttroney = {
      name: scheduleData && scheduleData.closingName ? scheduleData.closingName : '',
      phone: scheduleData && scheduleData.closingPhone ? scheduleData.closingPhone : '',
    };
    /* day of Contact on work  Info */
    this.dayOfContact = {
      name: scheduleData && scheduleData.workContactName ? scheduleData.workContactName : '',
      phone: scheduleData && scheduleData.workContactPhone ? scheduleData.workContactPhone : '',
      email: scheduleData && scheduleData.workContactEmail ? scheduleData.workContactEmail : '',
    };
    /* Agent Info */
    this.agentNames = {
      buyerAgentName: scheduleData && scheduleData.buyerAgentName ? scheduleData.buyerAgentName : '',
      sellerAgentName: scheduleData && scheduleData.sellerAgentName ? scheduleData.sellerAgentName : '',
    };
    let isOccupied = this.getvalue(this.occupiedOptions, scheduleData.isOccupied);
    let workResponsibleRole = this.getvalue(this.customerRoles, scheduleData.wcRole), responisblePayment = this.getvalue(this.customerRoles, scheduleData.responsibleRole);
    let scheduleInfo = this.getvalue(this.scheduleOptions, scheduleData.scheduleInfo);

    /* Important Questions Info */
    this.questions = {
      whenCompleted: scheduleData && scheduleData.scheduleRequestDate ? moment(new Date(scheduleData.scheduleRequestDate)).format('MM/DD/YYYY',) : '',
      isPrior: scheduleData ? (scheduleData.isPrior ? 'Yes' : 'No') : '',
      isocuupied: isOccupied ? isOccupied : '',
      workResponsibleRole: workResponsibleRole ? workResponsibleRole : '',
      responisblePayment: scheduleData && scheduleData.responsibleRole ? responisblePayment : '',
      progressWorkContact: scheduleData && scheduleData.progressContact ? scheduleData.progressContact : '',
      paymentContact: scheduleData && scheduleData.paymentContact ? scheduleData.paymentContact : '',
      scheduleInfo: scheduleInfo ? scheduleInfo : '',
      paymentContactEmail: scheduleData && scheduleData.paymentEmail ? scheduleData.paymentEmail : '',
      paymentContactPhone: scheduleData && scheduleData.paymentPhone ? scheduleData.paymentPhone : '',
    };
    /* Additional Info */
    this.additional = {
      additionalShare: scheduleData && scheduleData.additionalShare ? scheduleData.additionalShare : '',
      additionalWork: scheduleData && scheduleData.additionalWork ? scheduleData.additionalWork : '',
    };
  }
  getvalue(options, data) {
    let value;
    options.forEach(option => {
      if (option.value == data) {
        value = option.viewValue;
      }
    });
    return value;
  }
  downloadScheduleInfo() {
    var element = document.getElementById('printForm');
    var name = this.capitalizePipe.transform(this.fullName);
    var buyerProperty = this.capitalizePipe.transform(this.buyerProperty);
    html2pdf(element, {
      margin: 1,
      filename: name + '-' + buyerProperty + '-' + 'Scheduling Info.pdf',
      image: { type: 'base64', quality: 1 },
      html2canvas: { useCORS: false, scale: 2 },
      jsPDF: { unit: 'cm', format: 'a3', orientation: 'p' },
      pagebreak: { mode: 'avoid-all', after: '.break-after', before: '.break-before' }
    });
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/print-scheduling-info/print-scheduling-info.component.ts